
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['navigate', 'streetview', 'virtualtour', 'video'],
  props: {
    showStreetView: Boolean,
    virtualTourLink: String,
    videoLink: String,
  },
  methods: {
    onNavigate() {
      this.$emit('navigate');
    },
    onStreetView() {
      this.$emit('streetview');
    },
    onVirtualTour() {
      this.$emit('virtualtour');
    },
    onVideo() {
      this.$emit('video');
    },
  },
});
